import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { useUserContext } from '../context/PermissionsContext';

interface RoleBasedRouteProps {
  permissions: boolean[];
  children: ReactNode;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({
  permissions,
  children,
}) => {
  const { isSuperAdmin } = useUserContext();

  const isPermissionGranted = permissions.every(Boolean) || isSuperAdmin;

  return isPermissionGranted ? children : <Navigate to="/access-denied" />;
};

export default RoleBasedRoute;
